import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

export function AmericanFormattedDate({ date }: { date: string }) {
  const { t } = useTranslation()
  return (
    <span>
      {dayjs(date).isSame(dayjs(), 'day') ? t(`moment:calendar:today`) : dayjs(date).format('MM/DD/YYYY')} - <b>{dayjs(date).format('h:mm A')}</b>
    </span>
  )
}
